export const calculateCost = (vehicleNums: number, taskNums: number) => {
    const vehicleCost = vehicleNums * 590;
    const taskCost = taskNums * 8;
    return vehicleCost + taskCost;
}

export const displayCost = (vehicleNums: number, taskNums: number) => {
    const cost = calculateCost(vehicleNums, taskNums);
    return `예상 최적화 비용 ${cost.toLocaleString()}원`;
};
